import React, { useEffect, useRef, useState } from 'react'
import { useRest } from '../../contexts/rest/use'
import { useConfig } from '../../contexts/config/use'
import { TicketCancelled } from './ticket_cancelled';
import { TicketCalled } from './ticket_called'
import { TicketWaiting } from './ticket_waiting'
import { useTranslation } from '../../contexts/i18n/use'
import useTheme from '@material-ui/core/styles/useTheme'
import makeStyles from '@material-ui/core/styles/makeStyles'
import { Header } from '../header'
import { CancelTicketInfo } from './cancel_ticket_info';
import CircularProgress from '@material-ui/core/CircularProgress';
import { useHistory } from "react-router-dom"
import { isFalsyOrEmpty } from '../helpers/object';
import { GetParametersFromHash } from '../helpers/search';
import { Queuedata } from '../../services/dto/queuedata.dto';
import { ClearOutdatedStorage } from '../helpers/clearstorage';

export const TicketPage = () => {
  const { state: { ticket }, actions: { handleCancelTicket, qrToDirectTicket } } = useRest();
  const { state: { config }, actions: {GetOfficeIDFromUrlID, GetQueueIDfromUrlID, ReloadConfiguration, IsOfficeActive, ShouldShowTicketInfo }} = useConfig();
  const [searchparams, setSearchParams] = useState();
  const [formdata, setformdata] = useState();
  const { actions: {t, dt, tt}} = useTranslation();
  const soundRef = useRef();
  const [modal, setModal] = useState();
  const [called, setCalled] = useState(false);
  const history = useHistory();
  const theme = useTheme();
  const classes = useStyles(theme);
  
  const cancelTicketModal = () => {
    if (!modal)
      setModal(true);
  }

  const cancelTicketCallback = () => {
    setModal(false);
    handleCancelTicket();
  }

  const closeModalCallback = () => {
    setModal(false);
  }

  useEffect(() => {
    var tickettext = JSON.parse(localStorage.getItem("tickettext"));
    sessionStorage.removeItem("formdata");
    if ( tickettext )
      setformdata(tickettext)
  },[])

  const DingDong = () => {
    if (config && ticket.meetUpLocation && called === false && config.playSound)
    {
      setCalled(true);
      soundRef.current.play();
    }
  }

  useEffect(() => {
    if (!isFalsyOrEmpty(ticket))
      DingDong();
  }, [ticket])

  useEffect(() => {
      if (config) 
      {

        var oldbaseurl = localStorage.getItem("baseurl");
        if (window.location.pathname !== oldbaseurl)
        {
          ClearOutdatedStorage();
          localStorage.setItem("baseurl", window.location.pathname);
          ReloadConfiguration();
          window.location.reload();
          return;
        }

        if (isFalsyOrEmpty(ticket) || ticket.cancelled)
        {
          const searchParams = GetParametersFromHash();
          if (searchParams)
          {
            searchParams.officeID = GetOfficeIDFromUrlID(searchParams.officeID);
            searchParams.queueID = GetQueueIDfromUrlID(searchParams.officeID, searchParams.queueID);
            setSearchParams(searchParams);
          }
          else
          {
            let officeID = localStorage.getItem("selectedoffice");
            let queueID = localStorage.getItem("selectedqueue");
            let segmentID = sessionStorage.getItem("segementID");
            let serviceID = sessionStorage.getItem("serviceID");
  
            if (config && config.uselandingpage && !officeID && (!queueID || (!segmentID && !serviceID)))
              history.push("/");
            else
              history.push("queues");
          }
        }
      }
  }, [config])

  useEffect(() => {
    if(searchparams && isFalsyOrEmpty(localStorage.getItem("ticket")))
    {
      var hash = window.location.hash.split("?")
      window.history.replaceState({}, '', window.location.origin + window.location.pathname + hash[0])
      var queuedata = new Queuedata(searchparams['queueID'], searchparams['segmentID'], searchparams['serviceID']);
      if (searchparams.officeID && (queuedata.queueID || (queuedata.segmentID && queuedata.serviceID)))
        qrToDirectTicket(searchparams.officeID, queuedata, t('queuepage.customertext'));
      else
        history.push("404")
    }
  },[searchparams])

  const ActualTicket = () => {
    var savedticket = JSON.parse(localStorage.getItem("ticket"));
    let officeID = localStorage.getItem("selectedoffice");
    if (!isFalsyOrEmpty(officeID))
    {
      if (!IsOfficeActive(officeID))
      {
        //If this is false then the office has been closed or something
        localStorage.removeItem("selectedoffice");
        localStorage.removeItem("ticket");
        savedticket = null;
        history.push("404");
      }
    }
    if (!isFalsyOrEmpty(savedticket) && !isFalsyOrEmpty(config))
    {
      if (savedticket.cancelled)
        return <TicketCancelled 
                ticket={savedticket} 
                cancelTicketCallback={handleCancelTicket} 
                timeouttext={t('ticketpage.ended')} 
                throwtickettext={t('ticketpage.finish')} 
                dynamicheading={tt("dynamicheading", localStorage.getItem("selectedqueue"), "cancelled")}
                dynamicfooter={tt("dynamicfooter", localStorage.getItem("selectedqueue"), "cancelled")}
                showticketnumber={ShouldShowTicketInfo("ticketnumber")}
              />
      else if (savedticket.meetUpLocation)
        return <TicketCalled ticket={savedticket} 
                successtext={t('ticketpage.yourturn')} 
                meetuptext={t('ticketpage.placetogoto')} 
                dynamicheading={tt("dynamicheading", localStorage.getItem("selectedqueue"), "called")}
                dynamicfooter={tt("dynamicfooter", localStorage.getItem("selectedqueue"), "called")}
                formdata={formdata ? formdata.map(x => { return {id: dt(officeID, x.id), value: x.value}}) : ""}
                showticketnumber={ShouldShowTicketInfo("ticketnumber")}
                showdirection={ShouldShowTicketInfo("showdirection")}
                showFormsData={ShouldShowTicketInfo("formsdata")}
              />
      else
        return (
          <>
          { modal ? <CancelTicketInfo cancelticketcallback={cancelTicketCallback} closemodalcallback={closeModalCallback} /> : <span/> }
          <TicketWaiting 
            ticket={savedticket} 
            cancelTicketCallback={cancelTicketModal} 
            peopleaheadtext={t('ticketpage.peopleahead')} 
            ticketnumbertext={t('ticketpage.ticketnumber')} 
            leavequeuetext={t('ticketpage.leavequeue')} 
            formdata={formdata ? formdata.filter(a => a.value !== "").map(x => { return {id: dt(officeID, x.id) || x.id, value: x.value}}) : ""}
            dynamicheading={tt("dynamicheading", localStorage.getItem("selectedqueue"), "waiting")}
            dynamicfooter={tt("dynamicfooter", localStorage.getItem("selectedqueue"), "waiting")}
            showticketnumber={ShouldShowTicketInfo("ticketnumber")}
            showpeopleahead={ShouldShowTicketInfo("peopleahead")}
            showFormsData={ShouldShowTicketInfo("formsdata")}
            />
          </>
        )
    }
    else
    return (
      <div className={classes.spinnerwrapper}>
        <CircularProgress className={[classes.spinner, "Spinner"].join(' ')}/>
      </div>
    )
  }

  return (
    <div className={classes.container}>
      <Header/>
        { ActualTicket() }
        { config ? <audio ref={soundRef} id="audio" src={config.soundFilePath} type="audio/mpeg"></audio> : <span/>}
    </div>
  )
}

const useStyles = makeStyles({
  container: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    flex: '1 0 auto'
  },
  spinner: theme => ({
    color: theme.palette.primary.main,
    height: '80%',
    width: '80%'
  }),
  spinnerwrapper: {
    height: '100%',
    width: '100%',
    flex: '1 0 auto',
    justifyContent: 'center',
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column'
  }
})

